import { Button, Group, Modal, Stack, TextInput } from "@mantine/core";
import { useState } from "react";
import { createPool } from "../../../api/EmailAPI";
import BackButton from "../../../components/View/BackButton";
import { IconPlus } from "@tabler/icons-react";

const CreatePool = ({ onFinish, type = "Email" }) => {
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    createPool({ name: data.name, type })
      .then((res) => {
        setOpened(false);
        onFinish?.({ id: res.data.pool_id, name: data.name });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Button size="compact-sm" onClick={handleOpen}>
        Créer un pool
      </Button>

      <Modal title="Créer un pool" opened={opened} onClose={handleClose}>
        <Stack component="form" onSubmit={handleSubmit}>
          <TextInput
            size="md"
            label="Nom du pool"
            placeholder="Pool"
            name="name"
            data-autofocus
          />

          <Group justify="end" mt={"md"}>
            <BackButton onClick={handleClose} />

            <Button
              leftSection={<IconPlus size={18} />}
              type="submit"
              loading={loading}
            >
              Créer le pool
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default CreatePool;
